import ReactPlayer from "react-player/lazy";
import AudioRecorder from '../../../sharedComponents/AudioRecorder/AudioRecorder';
// import styled from 'styled-components';

// const CoverImageWrapper = styled.div`
//   /* display: flex; */
// `
// const CoverImage = styled.img`
//   display: block;
//   width: 100%;
//   height: 200px;
//   object-fit: cover;
// `

export default ({
  soefiaConfig = {},
  questionId,
  answers,
  setAnswers,
  largeFonts,
  extraLargeFonts,
  setIsRecordingInProgress
}) => {
  const titleFontSize = extraLargeFonts ? '72px' : largeFonts ? '60px' : '48px'

  const descriptionFontSize = extraLargeFonts ? '46px' : largeFonts ? '34px' : '22px'

  const {
    title,
    description = '',
    videoUrl = '',
    challengeUrl = '',
    challengeImage = '',
    autoStartRecording,
  } = soefiaConfig

  const promptId = 'intro'; // Always use "intro" as our promptId for any data attached to the start panel

  const answerObj = answers[questionId] || {};

  const {
    soefiaAnswer = {}
  } = answerObj;

  const soefiaAnswerPrompObj = soefiaAnswer[promptId] || {}

  const {
    files = []
  } = soefiaAnswerPrompObj;

  const blobFromUrl = async (mediaBlobUrl) => {
    const response = await fetch(mediaBlobUrl);
    const blob = await response.blob();
    return blob;
  };

  const fileFromBlob = (blob, fileName = "recording.wav") => {
    return new File([blob], fileName, { type: blob.type });
  };

  const initialRecordingFile = (files.map(({ file }) => file))[0]

  const initialRecording = initialRecordingFile ? URL.createObjectURL(initialRecordingFile) : undefined;

  const onUpdateRecordingAnswer = async (mediaBlobUrl = '') => {
    let file;
    if (mediaBlobUrl) {
      try {
        const blob = await blobFromUrl(mediaBlobUrl);
        file = fileFromBlob(blob, "userSoefiaRecording.wav");
      } catch (e) { console.log(e) }

      const formattedFiles = file ? [{ file }] : []

      const updateObj = { ...soefiaAnswer }
      if (promptId) {
        updateObj[promptId] = { files: formattedFiles }
      }

      setAnswers({
        ...answers,
        [questionId]: { soefiaAnswer: updateObj }
      })
    }
    setIsRecordingInProgress(false)
  }

  const onRecordingStarted = () => {
    setIsRecordingInProgress(true)
    if (challengeUrl) {
      window.open(challengeUrl, "_blank")
    }
  }

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column'
    }}>
      <div style={{ 
        fontSize: titleFontSize, 
        fontWeight: 'normal',
        // fontWeight: (extraLargeFonts || largeFonts) ? 'bold' : 'bold', 
        marginBottom: (extraLargeFonts || largeFonts) ? '40px' : '20px', whiteSpace: 'pre-wrap', textAlign: 'center',
        fontFamily: '"PassionOne-Regular", "Open Sans", sans-serif'
      }}>
        {title}
      </div>
      <div style={{ 
        fontSize: descriptionFontSize, 
        // fontWeight: (extraLargeFonts || largeFonts) ? 'bold' : 'bold', 
        marginBottom: (extraLargeFonts || largeFonts) ? '40px' : '20px', whiteSpace: 'pre-wrap', textAlign: 'center' 
      }}>
        {description}
      </div>
      {
        videoUrl &&
        <div style={{ display: 'flex', justifyContent: 'center' }}>
          <ReactPlayer url={videoUrl} controls={true} />
        </div>
      }
      {/* <div style={{ display: 'flex' }}> */}
      {
        (challengeUrl || challengeImage) &&
        <AudioRecorder
          key={'intro'}
          autoStartRecording={autoStartRecording}
          initialRecording={initialRecording}
          onRecordingChanged={onUpdateRecordingAnswer}
          onRecordingStarted={onRecordingStarted}
          buttonDisplayMap={{
            'ready': 'Play Challenge',
            'readyAgain': 'Replay Challenge',
            'recording': 'End Recording'
          }}
          buttonBackgroundColor='#f28a22'
        />
      }
      {/* {
        challengeImage &&
        <CoverImageWrapper>
          <CoverImage src={challengeImage} alt={`image-cover-${challengeImage}`}/>
        </CoverImageWrapper>
      } */}
      {/* </div> */}
    </div>
  )
}